export default "__VITE_ASSET__IYL3gQSl__"